<template>
  <Item
    tag="router-link"
    :to="{ name: 'project-openhouse-edit', params: { project: value.project.id, id: value.id } }"
    :type="value.typename.toLowerCase()"
    :title="title"
  >
    <template #details>
      <div v-if="$route.name === 'dashboard' || !value.references.length">
        <FontAwesomeIcon :icon="['fal', 'drafting-compass']" style="margin-right: 3px" />
        {{ value.project.name }}
      </div>
      <div v-if="value.references.length">
        <FontAwesomeIcon :icon="['fal', 'house']" style="margin-right: 3px" />
        {{ value.references.map(r => r.name).join(', ') }}
      </div>
    </template>
  </Item>
</template>

<script>
import Item from '@/components/ListItem'
import { Moment } from '@/filters'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    title() {
      return `${Moment(this.value.from, 'DD. MMM [kl.] HH.mm')} - ${Moment(this.value.to, 'HH.mm')}`
    },
  },
  filters: {
    Moment,
  },
  components: {
    Item,
  },
}
</script>

<style lang="scss">
.list-item--openhouse {
  a {
    text-decoration: none;
  }
}
</style>
